/** Textos do dialog "Exibir indicadores no Gantt" (iguais aos das telas de Carga de Trabalho). */
export const GANTT_INDICATORS_TITLE = "Exibir indicadores no Gantt";
export const GANTT_INDICATORS_HINT =
  "Mantenha pelo menos um indicador ativo para ver as obras no Gantt.";
export const GANTT_INDICATORS_LAST_ACTIVE_MESSAGE =
  "Este é o único indicador ativo. Ative outro antes de ocultá-lo.";
export const GANTT_INDICATORS_SAVE_LABEL = "Salvar";
